import { combineReducers } from "redux";
import states from "./reducers/auth";
import Station from "./reducers/station";
export const Reducer = combineReducers({
  auth: states,
  station: Station,
});
